import { Component } from '@angular/core';
import { EmailTemplate } from '../../models/EmailTemplate/EmailTemplate-model';
import { Role } from '../../models/shared/role.model';
import { DragulaService } from 'ng2-dragula';
import { Router, ActivatedRoute, Params } from "@angular/router";
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { NotificationService } from '../../services/notification/notification.service';
import { EmailTemplateService } from '../../services/EmailTemplate/EmailTemplate.service';
import { RoleService } from '../../services/role/role.service';
import { RolePermissionService } from '../../services/role/role-permission.service';
//import { Fields, FieldListModel } from '../../models/Fields/field-model';
@Component({
  selector: 'app-create-EmailTemplate',
  templateUrl: './create-EmailTemplate.component.html',
  styleUrls: ['./create-EmailTemplate.component.css']
})
/** create-action-emailTemplate component*/
export class CreateEmailTemplateComponent {
  public emailTemplate = new EmailTemplate();
  public Roles: Role[];
  isDisable = true;
  public htmlContent: any;
  configuration = {
    uiColor: '#ffffff',
    toolbarGroups: [{ name: 'clipboard', groups: ['clipboard', 'undo'] },
    { name: 'editing', groups: ['find', 'selection', 'spellchecker'] },
    { name: 'links' }, { name: 'insert' },
    { name: 'document', groups: ['mode', 'document', 'doctools'] },
    { name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
    { name: 'paragraph', groups: ['list', 'indent', 'blocks', 'align'] },
    { name: 'styles' },
    { name: 'colors' }],
    resize_enabled: false,
    removePlugins: 'save',
    extraPlugins: 'smiley,justify,indentblock,colordialog',
    colorButton_foreStyle: {
      element: 'font',
      attributes: { 'color': '#(color)' }
    },
    height: 188,
    removeDialogTabs: '',
    removeButtons: '',
    format_tags: 'p;h1;h2;h3;pre;div'
  }
  //public StringGenericFields: FieldListModel[];
  /** create-action-emailTemplate ctor */
  constructor(private readonly emailTemplateService: EmailTemplateService,
    private readonly notificationService: NotificationService,
    private readonly roleservices: RoleService,
    //private dragulaService: DragulaService,
    public toastr: ToastsManager,
    private readonly router: Router, private readonly rolePermissionService: RolePermissionService

  ) {
    this.rolePermissionService.GetRolePermissions("emailtemplate").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "create");
          });

          if (create.length > 0) {
            this.emailTemplate.TemplateVariablesClassName = "";
            this.emailTemplate.emailTemplateTriggerTo = "";
            this.emailTemplate.emailTemplateType = "";
            this.GetCustomerTypes();
            this.GetTriggerValues();
            this.GetTemplateVariables();
          }
          else {
            this.router.navigate(["/EmailTemplate-list"]);
          }
        }
        else {
          this.router.navigate(["/EmailTemplate-list"]);
        }
      }
    )


    //try {
    //  this.dragulaService.destroy("VAMPIRES");
    //} catch (e) {
    //}
    //this.dragulaService.createGroup("VAMPIRES", {

    //});
    //this.StringGenericFields = [{ name: "Bad Vamp" }
    //];
    //this.StringCategoryFields = [
    //  { name: "Dracula" }
    //];
    //this.dragulaService.dropModel("VAMPIRES").subscribe(args => {
    //  ;
    //});


  }
  dropdownList = [];
  selectedItems = [];
  dropdownSettings = {};
  ngOnInit() {
    this.dropdownList = [
      { item_id: 1, item_text: 'Mumbai' },
      { item_id: 2, item_text: 'Bangaluru' },
      { item_id: 3, item_text: 'Pune' },
      { item_id: 4, item_text: 'Navsari' },
      { item_id: 5, item_text: 'New Delhi' }
    ];
    this.selectedItems = [
      { item_id: 3, item_text: 'Pune' },
      { item_id: 4, item_text: 'Navsari' }
    ];
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'roleID',
      textField: 'roleName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };
  }
  onItemSelect(item: any) {
    

    //this.emailTemplate.emailTemplateRoleIds.push(item.roleID);
  }
  onSelectAll(items: any) {
    

  }
  GetCustomerTypes() {
    this.roleservices.GetActiveRoles().subscribe(
      data => {

        this.Roles = data;
      }
    )
  }
  GetTriggerValues() {
    this.emailTemplateService.getEmailTemplateTriggerTo().subscribe(
      data => {

        this.emailTemplate.TriggerTo = data;

      }
    )
  }
  GetTemplateVariables() {
    this.emailTemplateService.getTemplateVariables().subscribe(
      data => {
        var unique = {};
        var distinct = [];
        for (var i in data) {
          if (typeof (unique[data[i].templateVariableClass]) == "undefined") {
            distinct.push(data[i]);
          }
          unique[data[i].templateVariableClass] = 0;
        }

        //var unique = [new Set(data.map(item => item.templateVariableClass))];
        this.emailTemplate.TemplateVariablesClass = distinct;
      }
    )
  }



  AddVariable(name: string) {

    if (typeof (this.emailTemplate.emailTemplateContent) == 'undefined')
      this.emailTemplate.emailTemplateContent = "";
    this.emailTemplate.emailTemplateContent += ' ' + name;

  }
  GetTemplateVariableByClassName(name: string) {

    this.emailTemplateService.getTemplateVariablesByClass(name).subscribe(
      data => {

        this.emailTemplate.TemplateVariables = data;


      }
    )
  }
  //onContentChange(html: string): void {
  //  this.emailTemplate.emailTemplateDetail = html;
  //}

  onSubmit() {
    this.isDisable = false;
    this.emailTemplate;
    //var i= document.write(this.emailTemplate.emailTemplateRoleIds.roleID.join(","));
    this.emailTemplate.emailTemplateRoleIds = Array.prototype.map.call(this.emailTemplate.RoleIds, s => s.roleID).toString();
    this.emailTemplateService.addEmailTemplate(this.emailTemplate).subscribe(
      data => {

        if (data) {
          this.toastr.success('Email Template has been Saved.', 'Success');
          setTimeout(() => {
            this.router.navigate(["/EmailTemplate-list"]);
          }, 2000);
        }
        else {
          this.toastr.error('Error occurred. Please try again', 'Error');

        }

      });
    //this.EmailTemplateService.AddEmailTemplate(this.emailTemplate);
  }
}



// WEBPACK FOOTER //
// ./src/app/EmailTemplate/create-EmailTemplate/create-EmailTemplate.component.ts